import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import fungalNail from "../../assets/img/fungal-nail-test.jpeg";

/**
 * Dermatophyte Fungal Infection Testing detail page component
 */
const FungalTestingDetail = () => {
  return (
    <ServiceDetailLayout
      title="Dermatophyte Fungal Infection Testing"
      description="Professional dermatophyte fungal infection testing using immune-chromatography. Quick and accurate diagnosis of fungal nail infections."
      image={fungalNail}
      imageAlt="Fungal Nail Testing"
    >
      <h1 className="gs-u-mb+">Dermatophyte Fungal Infection Testing</h1>
      <p className="text--large gs-u-mb++">
        Nail fungus infections are a widespread issue that can impact any nail,
        particularly those on the toes.
      </p>

      <p className="gs-u-mb+">
        These infections are triggered by various fungi, including candida – the
        organism responsible for thrush – though the most frequent culprits are
        dermatophyte fungi, which also lead to athletes foot.
      </p>

      <p className="gs-u-mb++">
        Fungal nail infections happen when the fungal spores invade the space
        between your nail and the skin beneath (the nail bed) and consume the
        skin or keratin in the nail. This can lead to the nail detaching from
        the nail bed, resulting in nails that look opaque or white at the edges.
        Additionally, some fungal infections can cause nails to become
        discoloured, thick, and challenging to trim.
      </p>

      <h2 className="gs-u-mb+">The Challenge of Diagnosis</h2>
      <p className="gs-u-mb+">
        For a long time, Podiatrists have been skilled at recognizing and
        recommending treatments for fungal nail issues. However, until recently,
        we've struggled to consistently verify these diagnoses with tests.
      </p>
      <p className="gs-u-mb++">
        In the past, we relied on patients to bring in a nail clipping to their
        doctor, who would then send it to the lab for analysis, and the results
        could take as long as 6 weeks. Sometimes, the results would show no
        infection, even though we were aware of a fungal infection, possibly
        because the nail clipping wasn't collected properly or was stored for a
        few days before testing.
      </p>

      <h2 className="gs-u-mb+">Our Advanced Testing Solution</h2>
      <p className="gs-u-mb++">
        Our Fungal Nail Infection testing offers a fast, precise (over 97%) and
        highly effective in-clinic test for detecting dermatophytes, which are
        the leading cause of fungal nail infections.
      </p>

      <h2 className="gs-u-mb+">The Testing Process</h2>
      <p className="gs-u-mb+">
        The examination is completed within five minutes and does not cause any
        pain or discomfort. All that's needed is a proper nail clipping and
        immediate processing at our clinic.
      </p>
      <p className="gs-u-mb++">
        You'll receive the results on the same day following the examination.
        Once a diagnosis is reached, we'll talk about possible treatment methods
        with you. These can range from conservative care to nail fenestration or
        laser therapy.
      </p>

      <h2 className="gs-u-mb+">Revolutionary Approach</h2>
      <p className="gs-u-mb+">
        We're revolutionising the approach to diagnosing and treating fungal
        nail infections. This means you won't have to wait for treatment,
        allowing us to accelerate your journey from having toenails that are
        embarrassing and unhealthy to having nails that are both aesthetically
        pleasing and healthy.
      </p>
      <p className="gs-u-mb++">
        If you're worried about a nail issue like a fungal infection, reach out
        to us for a consultation that includes testing for fungal nail
        infections with our podiatrist.
      </p>
    </ServiceDetailLayout>
  );
};

export default FungalTestingDetail;
